import QuestionNew from './QuestionNew';

export default QuestionNew;
